import { createFileRoute } from "@tanstack/react-router";
import { RunViewer } from "@/components/run-viewer/RunViewer";
import { buildMetaTags } from "@/lib/seo/meta";

export const Route = createFileRoute("/_dashboard/runs/$runId")({
	head: () => {
		const meta = buildMetaTags({
			title: "Run History",
			description: "View run history and messages",
			noIndex: true,
			noFollow: true,
		});

		return { meta };
	},

	component: RunPage,
});

function RunPage() {
	const { runId } = Route.useParams();
	const runIdNumber = Number.parseInt(runId, 10);

	// Validate run ID
	if (Number.isNaN(runIdNumber)) {
		return (
			<div className="flex-1 flex items-center justify-center p-6">
				<div className="text-center">
					<p className="text-lg font-semibold mb-2">Invalid Run ID</p>
					<p className="text-muted-foreground">The run ID "{runId}" is not valid.</p>
				</div>
			</div>
		);
	}

	return <RunViewer runId={runIdNumber} />;
}
